import React from 'react'
import Banner from '../Components/Banner';
import BannerImage from "../Images/about-banner.jpg";
import ContactSection from '../Components/ContactSection';
import { Col, Container, Row } from 'react-bootstrap';
import AboutImage1 from '../Images/about/a1.jpg';
import AboutImage2 from '../Images/about/a2.jpg';
import AboutImage3 from '../Images/about/Our Kitchen.jpg';
import AboutImage4 from '../Images/about/Our Team.jpg';
import AboutImage5 from '../Images/about/From Corporate to Hospitality.jpg';
import Client1 from '../Images/about/gsr/1.svg';
import Client2 from '../Images/about/gsr/2.svg';
import Client3 from '../Images/about/gsr/3.svg';
import Client4 from '../Images/about/gsr/4.svg';
import Client5  from '../Images/about/gsr/5.svg';
import "./Css/About.css";
import gallery1 from "../Images/about/1.jpg";
import gallery2 from "../Images/about/2.jpg";
import gallery3 from "../Images/about/3.jpg";
import gallery4 from "../Images/about/4.jpg";
import gallery5 from "../Images/about/5.jpg";
const AboutUs = () => {
  
  
  const bannerTitle = (
    <>
      About Us
    </>
  );
  const bannerContent = "";
  const bannerConclude = "";
  
  return (
    <section className='about-content'>
      <Banner image={BannerImage} propAlt={"Home Banner"} 
          bannerTitle={bannerTitle} bannerContent={bannerContent} bannerConclude={bannerConclude} />    
        <section className='about-section-one section-pad'  >
          <Container>
            <Row className='d-flex align-items-center justify-content-center'>
              <Col lg='3' xs={12}>
                <div className='shape-img'>
                  <img className='img-responsive' src={AboutImage1} alt='About Sri Maha Caterers' />
                </div>
              </Col>
              <Col lg={6} xs={12}>
                <div className='about-center-content text-center pl-5 pr-5'>
                  <h3 className='title'>Sri Maha Caterers</h3>
                  
                  <p>
                  At Sri Maha Caterers, we don't just serve meals — we craft dining experiences. With highly specialized expertise in lavish wedding, reception, corporate, and special events catering, we combine classic favorites with refined presentation. Quality, sophistication, and warm hospitality characterize us. Each course is hand-prepared, fueled by our passion for excellence and keen attention to detail. From private parties to upscale affairs, we craft every occasion we service an exquisite slice of luxury that will leave your guests speechless and your belly's full.


                  </p>
                </div>
              </Col>
              <Col lg='3' xs={12}>
                <div className='shape-img'>
                  <img className='img-responsive' src={AboutImage2} alt='About Sri Maha Caterers' />
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className='about-section-two'>          
            <Row className='d-flex align-items-center justify-content-center'>
              <Col lg={6} xs={12} className='p-0'>
                <div className='about-left-content pl-5 pr-5'>
                    <h3 className='title'>
                      Our Kitchen
                    </h3>
                    <p className='text-justify'>
                    The heart and soul of Sri Maha Caterers is our 6,000 sq. ft., state-of-the-art, centralized kitchen, designed to the finest standards of quality and hygiene. Fully FSSAI-approved and equipped with the best cooking technology, our kitchen is well-equipped to handle events of every shape and size with perfection and economy. From live counters to conventional fare, we prepare it all under one roof. We also
welcome clients to taste and examine, ensuring full transparency and confidence
in our process. Here, every dish begins with discipline, focus, and an
unrelenting commitment to excellence.


                    </p>
                </div>
              </Col>
              <Col lg={6} xs={12} className='p-0'>
                <img className='img-responsive' src={AboutImage3} alt='About Sri Maha Caterers' />
              </Col>
            </Row>          
        </section>
        <section className='about-section-two'>          
            <Row className='d-flex align-items-center justify-content-center'>
              
              <Col lg={6} xs={12} className='p-0'>
                <img className='img-responsive' src={AboutImage4} alt='About Sri Maha Caterers' />
              </Col>
              <Col lg={6} xs={12} className='p-0'>
                <div className='about-left-content pl-5 pr-5'>
                    <h3 className='title'>
                      Our Team
                    </h3>
                    <p className='text-justify'>
                    At Sri Maha Caterers, our staff is at the core of everything that we undertake. Our master chefs and culinary experts, our experienced service staff and event managers, every one of them oozes passion, precision, and professionalism. With decades of cumulative experience in the art of fine dining catering, our staff knows the science of detail, timing, and presentation. Taught to the level of hospitality excellence, we toil quietly in the background to deliver each event with perfection. We're not just serving food — we're the commitment of a caring staff.


                    </p>
                </div>
              </Col>
            </Row>          
        </section>
        <section className='about-section-two mb-5'>          
            <Row className='d-flex align-items-center justify-content-center'>
              <Col lg={6} xs={12} className='p-0'>
                <div className='about-left-content pl-5 pr-5'>
                    <h3 className='title'>
                    From Corporate to Hospitality — A Journey of Passion
                    </h3>
                    <p className='text-justify'>
                    From boardrooms to banquets — our MD's story started in the corporate sector, but his heart was always with hospitality. What began as passion has evolved into GSR Hospitality, a high-end catering brand catering to Telangana and Andhra Pradesh. With an abiding love for food, people, and celebration, he established Sri Maha Caterers to serve not only meals, but memories. This is what happens when passion turns into purpose.


                    </p>
                </div>
              </Col>
              <Col lg={6} xs={12} className='p-0'>
                <img className='img-responsive' src={AboutImage5} alt='About Sri Maha Caterers' />
              </Col>
            </Row>          
        </section>
        <section className='section-pad client-sec'>
          <Container>
            <h3 className='title text-center mb-5'>
            Our Sister Companies
            </h3>
            <Row className='d-flex align-items-center justify-content-center  mb-5'>
              <Col xs={12} lg={4}>
                <div className='icon-bg'>
                  <img className='img-responsive' src={Client1} alt='client' />
                </div>
              </Col>
              <Col xs={12} lg={4}>
                <div className='icon-bg'>
                  <img className='img-responsive' src={Client2} alt='client' />
                </div>
              </Col>
              <Col xs={12} lg={4}>
                <div className='icon-bg'>
                  <img className='img-responsive' src={Client3} alt='client' />
                </div>
              </Col>
              </Row>
              <Row className='d-flex align-items-center justify-content-center '>
              <Col xs={12} lg={4}>
                <div className='icon-bg'>
                  <img className='img-responsive' src={Client4} alt='client' />
                </div>
              </Col>
              <Col xs={12} lg={4}>
                <div className='icon-bg'>
                  <img className='img-responsive' src={Client5} alt='client' />
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="gallery-section section-pad">
          <Container>
            
          <h2 className="text-center mb-5">Gallery</h2>
          <Row className="d-flex align-items-stretch justify-content-center top-testi">
            <Col xs={12} lg={4} className="d-flex flex-column justify-content-center h-100 mb-4 mb-lg-0">
              <img className="img-responsive w-100" src={gallery1} alt="" />
            </Col>

            <Col xs={12} lg={4} className="d-flex flex-column justify-content-between h-100">
              <Row className="gap-4 h-100">
                <Col xs={12} className="h-50">
                  <img className="img-responsive w-100 h-100 object-fit-cover" src={gallery2} alt="" />
                </Col>
                <Col xs={12} className="h-50">
                  <img className="img-responsive w-100 h-100 object-fit-cover" src={gallery3} alt="" />
                </Col>
              </Row>
            </Col>

            <Col xs={12} lg={4} className="d-flex flex-column justify-content-between h-100">
              <Row className="gap-4 h-100">
                <Col xs={12} className="h-50">
                  <img className="img-responsive w-100 h-100 object-fit-cover" src={gallery4} alt="" />
                </Col>
                <Col xs={12} className="h-50">
                  <img className="img-responsive w-100 h-100 object-fit-cover" src={gallery5} alt="" />
                </Col>
              </Row>
            </Col>
          </Row>
          <div className='gallery-btn-sec text-center'>
          <a href="/" className='mt-5 btn-style' title='View All'>
            View All
          </a>
          </div>
          </Container>
        </section>
        <ContactSection />
    </section>
  )
}

export default AboutUs